import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { validatePhoneUseCase } from "../../../PaymentDetailsSection/InputSection/components/PhoneInput/validatePhone.case";
import { validateSum } from "../../../PaymentDetailsSection/InputSection/components/SumInput/logic/validateSum.case";
import { getPaymentOptionTypeFromId } from "./utils";
import { EPaymentMethod, EPaymentMethodGranular } from "../../../../../../../../dependencies/getContent/constants";
import { withProcessingLogic } from "../../../../../../../../utils/utils.domain";
import { produce } from "../../../../../../../../../libs/immer";
import { findFirst } from "../../../../../../../../../utils/arrays";
import { closeStatusPopupUseCase } from "../../../../../Popups/RequestStatus/logic/closePopup.case";
import { EStatus } from "../../../../../../../../../constants";
import { EModalStep } from "../../../ModalLayout/EModalStep";
import { EUserType } from "../../../PaymentDetailsSection/InputSection/components/PhoneInput/api/constants";
import { getUserType } from "../../../PaymentDetailsSection/InputSection/components/PhoneInput/utils";
var handleSBPScenario = function handleSBPScenario(_, setState) {
  setState(function (prev) {
    return produce(prev, function (draft) {
      draft.scenario = {
        type: EPaymentMethod.SBP
      };
      draft.isProcessing = false;
    });
  });
};
var handleSberPayScenario = function handleSberPayScenario(_, setState) {
  setState(function (prev) {
    return produce(prev, function (draft) {
      draft.scenario = {
        type: EPaymentMethod.SberPay,
        step: 0,
        captchaInput: {
          value: ''
        },
        phoneInput: {
          value: ''
        }
      };
      draft.isProcessing = false;
    });
  });
};
var handleFttbScenario = function handleFttbScenario(_, setState) {
  setState(function (prev) {
    return produce(prev, function (draft) {
      draft.scenario = {
        type: 'email',
        emailInput: {
          value: ''
        }
      };
      draft.isProcessing = false;
    });
  });
};
var handlePaymentResult = function handlePaymentResult(setState, status) {
  setState(function (prev) {
    return produce(prev, function (draft) {
      draft.statusPopup = status;
      draft.isProcessing = false;
    });
  });
};
export var submitPaymentUseCase = function submitPaymentUseCase(_ref) {
  var getContent = _ref.getContent,
    getIsBeelineError = _ref.getIsBeelineError,
    submitPayment = _ref.submitPayment,
    getUserAccountInfo = _ref.getUserAccountInfo;
  return /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(getState, setState) {
      var state, phoneError, sumError, paymentType, isQuickPayment, _getUserAccountInfo, email, userType, fn;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            state = getState();
            closeStatusPopupUseCase(setState);
            // Validate inputs
            _context.next = 4;
            return withProcessingLogic(setState)(validatePhoneUseCase({
              getContent: getContent,
              getIsBeelineError: getIsBeelineError
            })(state.phoneInput.value, setState));
          case 4:
            phoneError = _context.sent;
            sumError = validateSum({
              getContent: getContent
            })(getState, setState);
            if (!(phoneError || sumError)) {
              _context.next = 9;
              break;
            }
            setState(produce(function (draft) {
              draft.mobileStep = EModalStep.PaymentType;
            }));
            return _context.abrupt("return");
          case 9:
            paymentType = state.selectedPaymentId && getPaymentOptionTypeFromId(state.selectedPaymentId);
            isQuickPayment = state.quickOptions.some(function (option) {
              return option.id === state.selectedPaymentId;
            });
            _getUserAccountInfo = getUserAccountInfo(), email = _getUserAccountInfo.email;
            userType = getUserType(state.phoneInput.value);
            fn = findFirst([
            // ШПД Карта
            [EPaymentMethodGranular.Card, EPaymentMethodGranular.SavedCard].includes(paymentType) && userType === EUserType.Fttb && !email && function () {
              return handleFttbScenario(state, setState);
            },
            // Regular SBP
            !isQuickPayment && paymentType === EPaymentMethodGranular.SBP && function () {
              return handleSBPScenario(state, setState);
            },
            // Regular SberPay
            !isQuickPayment && paymentType === EPaymentMethodGranular.SberPay && function () {
              return handleSberPayScenario(state, setState);
            },
            // Quick Payment
            function () {
              withProcessingLogic(setState)(submitPayment(getState, setState)).then(function (result) {
                if (!result) return;
                handlePaymentResult(setState, result);
              }).catch(function (e) {
                console.error(e);
                handlePaymentResult(setState, EStatus.Error);
              });
            }]);
            fn === null || fn === void 0 || fn();
          case 15:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function (_x, _x2) {
      return _ref2.apply(this, arguments);
    };
  }();
};